/*
 * Function to save a referral.
 */

// WR-1378: Appointment Type and Service Activity IDs for Aviva MH mapping
// Note: This mapping should ideally be data-driven at the backend, but time does not allow
const MH_ASSESSMENT_SERVICE_ACT = 2060;
const AVIVA_CYP_MH_ASSESSMENT_APP_TYPE = 1001;
const MH_MINOR_ASSESSMENT_SERVICE_ACT = 2061;

const saveReferral = (api, appState, update) => {
    const {
        Client: { ClientPartyID },
        serviceActivityId,
        appointmentType,
        personalData,
        injuries
    } = appState;

    // WR-1378: Map MH Assessment with Aviva CYP MH Assessment appointment type
    // to MH Minor Assessment to indicate CYP appointment
    // TODO: This mapping should be data-driven at the backend, but time does not allow
    let effectiveServiceActivityId = serviceActivityId;
    if (appointmentType?.AppointmentTypeID === AVIVA_CYP_MH_ASSESSMENT_APP_TYPE &&
        serviceActivityId === MH_ASSESSMENT_SERVICE_ACT) {
        effectiveServiceActivityId = MH_MINOR_ASSESSMENT_SERVICE_ACT;
    }

    // the API uses specific keys. ClaimNumber is only sent when entered, so
    // other diaries' payloads are unchanged; the API maps it to a Reference Type
    const injuriesMapped = injuries?.map(i => {
        const mapped = { Comments: i.comment, InjuryRegionId: i.pkRegionId };
        const claimNumber = i.claimNumber?.trim();
        if (claimNumber) {
            mapped.ClaimNumber = claimNumber;
        }
        return mapped;
    });

    const referralData = { ...personalData, InjuryList: injuriesMapped };

    return api
        .saveReferralForm(ClientPartyID, effectiveServiceActivityId, referralData)
        .then(r => r.apiResult);
};

export default saveReferral;
